import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Button } from "matsuri-ui";
import { Link } from "react-router-dom";
import { css } from "@emotion/react";
import { theme } from "../theme";
import { useAuth } from "../domain/api/auth";
import { Logo } from "./Logo";
export const APP_HEADER_HEIGHT = 61;
export const AppHeader = ({ controlls }) => {
    const { authenticated, logout } = useAuth();
    return (_jsx("div", { css: css `
        background-color: #fff;
        border-bottom: 3px solid ${theme.palette.intentions.primary.main};
      `, children: _jsxs("header", { css: css `
          display: flex;
          align-items: center;
          justify-content: space-between;
          max-width: 1280px;
          height: 58px;
          padding: 8px 2vw;
          margin: auto;
        `, children: [_jsx(Link, { to: "/", css: css `
            display: flex;
          `, children: _jsx(Logo, {}) }), _jsxs("div", { css: css `
            display: flex;
            gap: 16px;
            align-items: center;
          `, children: [controlls, 
                        /**
                         * TODO: ユーザーメニューのようなものを作る
                         */
                        authenticated ? (_jsx(Button, { type: "button", onClick: logout, children: "\u30ED\u30B0\u30A2\u30A6\u30C8" })) : null] })] }) }));
};
